import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import { Tag, Typography, Row, Col, Divider } from 'antd';
import L from 'leaflet';
import moment from 'moment';

const { Text, Title } = Typography;

// Style helper function for status tags
const getStatusTagColor = (status) => {
  switch (status) {
    case 'bozza':
      return 'default'; // grigio
    case 'inviato':
      return 'blue';
    case 'accettato':
      return 'warning'; // giallo/arancione
    case 'pagato':
      return 'success'; // verde
    case 'rifiutato':
      return 'error'; // rosso
    default:
      return 'blue';
  }
};

// Format currency helper
const formatCurrency = (value) => {
  return new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR'
  }).format(value);
};

// Create custom marker icons for different statuses
const createStatusIcon = (color) => {
  return new L.Icon({
    iconUrl: `https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-${color}.png`,
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  });
};

const statusIcons = {
  bozza: createStatusIcon('grey'),
  inviato: createStatusIcon('blue'),
  accettato: createStatusIcon('orange'),
  pagato: createStatusIcon('green'),
  rifiutato: createStatusIcon('red'),
  default: createStatusIcon('blue')
};

const QuoteMarker = ({ quote, coord }) => {
  if (!coord.latitude || !coord.longitude) return null;

  const { customer_pointer, subtotal, date, status, objectId } = quote;
  
  return (
    <Marker 
      position={[coord.latitude, coord.longitude]} 
      icon={statusIcons[status] || statusIcons.default}
    >
      <Popup>
        <div style={{ maxWidth: 300 }}>
          <Title level={5} style={{ marginBottom: 5 }}>
            <a 
              href={`https://eterno.onoranzefunebricloud.com/index.php?page=ofc_quote&quoteId=${objectId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Preventivo #{objectId.substr(objectId.length - 6)}
            </a>
          </Title>
          <Tag color={getStatusTagColor(status)}>
            {status === 'bozza' ? 'Bozza' : 
             status === 'inviato' ? 'Inviato' : 
             status === 'accettato' ? 'Accettato' : 
             status === 'pagato' ? 'Pagato' : 
             status === 'rifiutato' ? 'Rifiutato' : status}
          </Tag>
          <Divider style={{ margin: '10px 0' }} />
          
          <Row>
            <Col span={24}>
              <Text strong>Cliente:</Text>{' '}
              <Text>{customer_pointer?.nome} {customer_pointer?.cognome}</Text>
            </Col>
          </Row>
          
          {customer_pointer?.partita_iva && (
            <Row>
              <Col span={24}>
                <Text strong>P.IVA:</Text>{' '}
                <Text>{customer_pointer.partita_iva}</Text>
              </Col>
            </Row>
          )}
          
          <Row>
            <Col span={24}>
              <Text strong>Indirizzo:</Text>{' '}
              <Text>
                {customer_pointer?.indirizzo}{customer_pointer?.citta ? `, ${customer_pointer.citta}` : ''}
                {customer_pointer?.cap ? ` (${customer_pointer.cap})` : ''}
              </Text>
            </Col>
          </Row>
          
          <Divider style={{ margin: '10px 0' }} />
          
          <Row>
            <Col span={12}>
              <Text strong>Data:</Text>{' '}
              <Text>{moment(date?.iso || date).format('DD/MM/YYYY')}</Text>
            </Col>
            <Col span={12}>
              <Text strong>Totale:</Text>{' '}
              <Text>{formatCurrency(subtotal || 0)}</Text>
            </Col>
          </Row>
        </div>
      </Popup>
    </Marker>
  );
};

export default QuoteMarker;